import { ModalProvider } from '@private/modals';
import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

export const StyledModalProvider = styled(ModalProvider)`
  backdrop-filter: blur(15px);
  background: ${getPrefixedVar(['components', 'modalContainer', 'bg'])};
  z-index: 999;
`;
